/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function getURL() {
    
  var url = window.location.origin;
  return url;
  
}

if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  $("#mg-cart-toggle").attr("data-action", "");
  window.scrollTo(0, 0);
} else {
  $("#mg-cart-toggle").attr("data-action", "toggle-mini-cart");
}

var $contents = $('.tab-content');
//$contents.slice(1).hide();
$('.tab').click(function() {
  //alert(this.id);
  if(this.id=="taball") {
    $contents.slice(1).show();
    $contents.parent().fadeIn('fast');
  } else if(this.id=="tabhome") { //https://f75j07lcng8yzqdf-52523958430.shopifypreview.com/blogs/news
    window.open("https://www.polypet.com.sg/blogs/news","_self");
  } else {
  var $target = $('.' + this.id).show();
  $('.' + this.id).parent().fadeIn('fast');  
  $contents.not($target).hide(); 
  $contents.not($target).parent().fadeOut('fast');  
  }
});



let slideIndex = 1;
showSlides(slideIndex);

// Next/previous controls
function plusSlides(n) {
  showSlides(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName("blogSlides");
  let dots = document.getElementsByClassName("dot");
  if (slides.length === 0) { return; }
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" blogactive", "");
  }
  if (slides[slideIndex-1]) { slides[slideIndex-1].style.display = "block"; }
  if (dots[slideIndex-1]) { dots[slideIndex-1].className += " blogactive"; }
}